import React from 'react';
import { IconButton } from '../../../../../../../components/IconButton';
import { BULK_REVIEW_NAVIGATION_TYPE } from '../../../..';

interface PropTypes {
  index: number;
  onPrevious: () => void;
  onNext: (navType: BULK_REVIEW_NAVIGATION_TYPE) => void;
}

export function NavigationButtons(props: PropTypes) {
  return (
    <div className='d-flex align-items-center gap-2 pb-2'>
      <IconButton
        iconName='bi-skip-start'
        buttonText='Previous'
        disabled={props.index === 0}
        color='secondary'
        position='start'
        onClick={props.onPrevious}
      />
      <IconButton
        iconName='bi-skip-end'
        buttonText='Skip'
        color='secondary'
        position='end'
        onClick={() => props.onNext('skipped')}
      />
    </div>
  );
}
